import { useQuery } from '../../lib';
import { useTribeClient } from '../../useTribeClient';
import { getPostTypeKey } from '../../utils/keys';
export const usePostType = (options) => {
    const { variables, fields = 'basic', useQueryOptions } = options;
    const { client } = useTribeClient();
    const postTypeKey = getPostTypeKey({ variables, fields });
    return useQuery(postTypeKey, () => client.postType.get(variables, fields), {
        ...useQueryOptions,
    });
};
//# sourceMappingURL=usePostType.js.map